import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api, unwrapObject } from "@/lib/api";
import { addRecent } from "./useRecents";

const ENTITY: Record<string, "Lead" | "Deal" | "Account" | "Contact"> = { leads: "Lead", deals: "Deal", accounts: "Account", contacts: "Contact" };

/** Notes each lead, deal, account or contact page the person opens, for the "Recently viewed" list */
export function RecentTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    const m = pathname.match(/^\/(leads|deals|accounts|contacts)\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i);
    if (!m) return;
    const entity = ENTITY[m[1]!]!;
    let live = true;
    // The preview carries the record's name, and only answers for a record the person may see
    api
      .get(`/api/Preview/${entity}/${m[2]}`)
      .then((r) => {
        const p = unwrapObject<{ title: string; subtitle: string }>(r);
        if (live && p.title) addRecent({ entity, id: m[2]!, label: p.title, sub: p.subtitle, to: pathname });
      })
      .catch(() => undefined);
    return () => {
      live = false;
    };
  }, [pathname]);
  return null;
}
